var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHogarDelNino(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 364.8",
    style: {
      enableBackground: "new 0 0 720 364.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D44345;}\n\t.st1{fill:#E8B285;}\n\t.st2{fill:none;}\n\t.st3{fill:#258D50;}\n\t.st4{fill:#885E3D;}\n\t.st5{fill:#404041;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_164_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_715_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_844_",
    points: "37.1,173.8 66.9,139.6 68.3,140.9 38.6,175  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_843_",
    points: "49.2,159.8 51.1,159.6 52.4,173.8 50.5,173.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_842_",
    points: "45.1,174.3 45.1,165.4 47,165.4 47,174.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_841_",
    points: "32.5,161.2 32.5,159.3 49.2,159.6 49.1,161.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_840_",
    points: "35.7,153.8 36.5,151.9 51.6,158.1 50.8,159.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_839_",
    points: "52.6,304.4 65.1,257.2 67,257.8 54.9,302.9 68.8,306 68.4,307.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_838_",
    points: "102.2,126.5 102.2,116.8 104.1,116.8 104.1,126.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_837_",
    points: "137.8,141.5 139,140 164.1,161.3 162.9,162.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_836_",
    points: "140.7,160 155,159 155.2,160.9 140.8,161.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_835_",
    points: "140.4,170.5 192.7,128.4 193.9,129.9 141.6,172  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_834_",
    points: "150.1,173.3 155.2,158.9 157,159.6 151.9,173.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_833_",
    points: "155.2,160 157.2,159.8 159.5,177.2 157.6,177.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_832_",
    points: "144.1,154.9 145,153.2 156.7,160 155.8,161.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_831_",
    points: "149.5,161.4 154.1,154.1 155.7,155.1 151.1,162.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_830_",
    points: "155,154.1 167.4,154.8 167.3,156.6 157.7,156.1 160.7,164.6 158.8,165.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_829_",
    points: "155.6,154.5 161.4,147.2 163,148.4 157.1,155.8  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_826_",
    d: "M124.5,299l4.2-30.2l-4.3-17l1.9-0.4l4.4,17.4l-4,28.7l17.3,2.9l-0.3,1.9L124.5,299L124.5,299z  M124.4,251.8L124.4,251.8L124.4,251.8L124.4,251.8L124.4,251.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_825_",
    points: "165.6,300.9 183.2,297 180.3,271 183.6,254.4 185.5,254.8 182.2,271.1 185.4,298.5 166.1,302.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_824_",
    points: "201.6,300.9 217,294.5 217,247.8 218.9,247.8 218.9,295.9 202.4,302.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_823_",
    className: "st0",
    points: "194.8,119.6 229.5,118.2 238.7,247.5 158.2,257.2 192.5,126.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_820_",
    d: "M191.9,126l2.3-6.7l0.2-0.4l35.7-1.3l9.3,130.5l-82.1,10L191.9,126L191.9,126z M193.2,126.3l-34.1,130.1 l79-9.6l-9.1-128l-33.6,1.3L193.2,126.3L193.2,126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_819_",
    className: "st1",
    d: "M184.6,85.3c0,0-1.8,33.8,21.3,32.8c0,0,22.6,0,24.4-36.7V61.8l-29.5-0.8l-14.9,12.3 L184.6,85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_816_",
    d: "M183.9,87.1c0-1.1,0-1.7,0-1.7l0,0h0.7l-0.7-0.1l1.3-12.3l15.3-12.6l30.4,0.8v20.4 c-0.9,18.5-7.1,27.9-13.1,32.6l0,0c-6,4.7-11.8,4.7-11.9,4.7l0,0c-0.3,0-0.7,0-1,0l0,0C185.1,118.8,183.9,93.8,183.9,87.1 L183.9,87.1z M185.2,87.1c0,3.3,0.3,11.1,3,17.9l0,0c2.7,6.8,7.5,12.6,16.7,12.7l0,0c0.3,0,0.7,0,1,0l0,0c0-0.1,5.4,0,11.1-4.4 l0,0c5.7-4.5,11.7-13.4,12.6-31.6l0,0V62.4L201,61.7l-14.5,12l-1.2,11.8l0,0C185.2,85.6,185.2,86.2,185.2,87.1L185.2,87.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_815_",
    className: "st0",
    points: "61.7,134.9 71.7,152.5 81.5,142.6 125.6,144.1 132.3,149.8 145,132 123.5,124.5  89.9,125.2 84,126.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_812_",
    d: "M61.1,135.1l-0.4-0.6l23.1-9.1l6-1l33.7-0.8l22.5,8l-13.7,18.9l-7-5.9l-43.6-1.5l-10.1,10.5L61.1,135.1 L61.1,135.1z M71.8,151.5l9.4-9.6l44.6,1.5l6.3,5.3l11.9-16.5l-20.6-7.4L90,125.5l-5.8,1L62.6,135L71.8,151.5L71.8,151.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_811_",
    className: "st1",
    d: "M75.5,90.5c0,0-1.5,25.9,18.6,29.1c0,0,43.4,6,38.2-24.2c-1.6-6.7-8.2-13.4-7.6-18.4 c0,0-30.4-14.3-41.7,1.2L75.5,90.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_808_",
    d: "M94.1,120.1C76,117.2,74.9,97,74.9,91.7l0,0c0-0.8,0-1.3,0-1.3l0,0v-0.2l7.7-12.5 c4.1-5.7,10.7-7.5,17.3-7.5l0,0c12.3,0,25.1,6.1,25.1,6.1l0,0l0.4,0.2v0.5c0,0.2,0,0.4,0,0.6l0,0c-0.1,4.4,6,11,7.6,17.6l0,0 c0.3,1.7,0.4,3.4,0.4,4.9l0,0c-0.1,18-19.5,20.5-30.9,20.6l0,0C97.6,120.6,94.1,120.1,94.1,120.1L94.1,120.1z M96.6,119.1 c1.5,0.1,3.5,0.2,6,0.2l0,0c5.6,0,13.1-0.7,19.1-3.4l0,0c6-2.8,10.4-7.5,10.5-15.9l0,0c0-1.4-0.1-3-0.4-4.7l0,0 c-1.4-6.1-7.6-12.5-7.6-17.8l0,0c0-0.1,0-0.2,0-0.3l0,0c-1-0.4-3.7-1.6-7.4-2.8l0,0c-4.7-1.5-10.8-3-16.8-3l0,0 c-6.4,0-12.5,1.7-16.3,6.9l0,0l-7.5,12.4c0,0.2,0,0.5,0,1.1l0,0c0,5.2,1.2,24.6,18.1,27.2l0,0l0,0l0,0 C94.3,118.8,95.2,119,96.6,119.1L96.6,119.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_807_",
    d: "M73.2,94.6c0,0,1.1-4.9,4.3-5.4c0,0,3.8,1.6,6-8.1c0,0,4.9-2.7,4.9,1.1v4.9c0,0,3.2-4.3,8.1-4.9 c0,0,5.4,0,4.3-4.9c0,0,10.9-1.1,11.9,3.8c0,0,1.1-3.1-1.1-4.9c0,0,5.9,2.7,11.9,3.3c0,0,10.8-2.7,12.4,1.6 c0,0-1.6-26.5-23.3-23.3c0,0-3.3,1.1-9.8,4.3c0,0-4.8,3.3-11.9,3.8c0,0-11.4-1.6-13,9.7C78,75.6,68.3,82.7,73.2,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_806_",
    d: "M100.7,91.8c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8 C99,88.1,100.7,89.8,100.7,91.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_805_",
    d: "M205.3,78c0,2.1-1.7,3.8-3.8,3.8s-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8S205.3,75.8,205.3,78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_804_",
    d: "M119.1,89.8c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8 C117.4,86.2,119.1,87.8,119.1,89.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_803_",
    d: "M223,78c0,2.1-1.7,3.8-3.8,3.8s-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8S223,75.8,223,78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_802_",
    className: "st2",
    d: "M107.1,99.5c5-0.5,6.3,7.8-0.4,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_801_",
    className: "st2",
    d: "M107.1,96.2c5-0.5,6.3,7.8-0.4,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_800_",
    d: "M107.1,97.1c1.8-0.1,3.1,1,3.2,2.8c0.2,2.2-1.6,3.4-3.6,3.6c-1.2,0.1-1.2,2,0,1.9c3-0.3,5.6-2.2,5.5-5.5 c-0.1-2.8-2.4-4.9-5.1-4.7C105.8,95.2,105.8,97.2,107.1,97.1L107.1,97.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_799_",
    className: "st0",
    d: "M91.3,103.1c0,2.5-2,4.4-4.4,4.4c-2.5,0-4.4-2-4.4-4.4s2-4.4,4.4-4.4S91.3,100.7,91.3,103.1z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_796_",
    d: "M81.8,103.1c0-2.8,2.3-5.1,5.1-5.1l0,0c2.8,0,5.1,2.3,5.1,5.1l0,0c0,2.8-2.3,5.1-5.1,5.1l0,0 C84.1,108.2,81.8,105.8,81.8,103.1L81.8,103.1z M83.1,103.1c0,2.1,1.7,3.8,3.8,3.8l0,0c2.1,0,3.8-1.7,3.8-3.8l0,0 c0-2.1-1.7-3.8-3.8-3.8l0,0C84.8,99.2,83.1,101,83.1,103.1L83.1,103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_795_",
    className: "st0",
    d: "M126.6,101.8c0,2.5-2,4.4-4.4,4.4c-2.5,0-4.4-2-4.4-4.4c0-2.5,2-4.4,4.4-4.4 C124.7,97.5,126.6,99.5,126.6,101.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_792_",
    d: "M117.1,101.8c0-2.8,2.2-5.1,5-5.1l0,0c2.8,0,5.1,2.3,5.1,5.1l0,0c0,2.8-2.3,5.1-5.1,5.1l0,0 C119.4,107,117.1,104.7,117.1,101.8L117.1,101.8z M118.4,101.8c0,2.1,1.7,3.8,3.8,3.8l0,0c2.1,0,3.8-1.7,3.8-3.8l0,0 c0-2.1-1.7-3.8-3.8-3.8l0,0C120.1,98.1,118.4,99.8,118.4,101.8L118.4,101.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_791_",
    className: "st0",
    d: "M199.2,97c0,2.5-2,4.4-4.4,4.4c-2.5,0-4.4-1.9-4.4-4.4c0-2.4,2-4.4,4.4-4.4 S199.2,94.6,199.2,97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_788_",
    d: "M189.7,97c0-2.8,2.2-5.1,5.1-5.1l0,0c2.8,0,5.1,2.3,5.1,5.1l0,0c0,2.8-2.3,5.1-5.1,5.1l0,0 C192,102.1,189.7,99.8,189.7,97L189.7,97z M191,97c0,2.1,1.7,3.8,3.8,3.8l0,0c2.1,0,3.8-1.7,3.8-3.8l0,0c0-2.1-1.7-3.8-3.8-3.8 l0,0C192.7,93.2,191,95,191,97L191,97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_787_",
    className: "st0",
    d: "M224.3,95.8c0,2.5-2,4.4-4.4,4.4s-4.4-2-4.4-4.4s2-4.4,4.4-4.4 C222.4,91.2,224.3,93.2,224.3,95.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_784_",
    d: "M214.9,95.8c0-2.8,2.3-5.1,5.1-5.1l0,0c2.8,0,5.1,2.3,5.1,5.1l0,0c0,2.8-2.3,5.1-5.1,5.1l0,0 C217.1,100.8,214.9,98.6,214.9,95.8L214.9,95.8z M216.1,95.8c0,2.1,1.7,3.8,3.8,3.8l0,0c2.1,0,3.8-1.7,3.8-3.8l0,0 c0-2.1-1.7-3.8-3.8-3.8l0,0C217.8,92,216.1,93.7,216.1,95.8L216.1,95.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_783_",
    className: "st3",
    d: "M225.1,132.3c0,2.4-2,4.4-4.4,4.4s-4.4-2-4.4-4.4s2-4.4,4.4-4.4 C223.1,128,225.1,129.9,225.1,132.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_780_",
    d: "M215.6,132.3c0-2.8,2.3-5.1,5.1-5.1l0,0c2.8,0,5.1,2.3,5.1,5.1l0,0c0,2.8-2.3,5.1-5.1,5.1l0,0 C217.9,137.4,215.6,135.1,215.6,132.3L215.6,132.3z M216.9,132.3c0,2.1,1.7,3.8,3.8,3.8l0,0c2.1,0,3.8-1.7,3.8-3.8l0,0 c0-2.1-1.7-3.8-3.8-3.8l0,0C218.6,128.6,216.9,130.2,216.9,132.3L216.9,132.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_779_",
    className: "st3",
    d: "M206.4,128.8c0,2.4-2,4.4-4.4,4.4s-4.4-2-4.4-4.4c0-2.5,2-4.5,4.4-4.5 C204.5,124.2,206.4,126.2,206.4,128.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_776_",
    d: "M196.9,128.8c0-2.8,2.3-5.1,5.1-5.1l0,0c2.8,0,5.1,2.3,5.1,5.1l0,0c0,2.8-2.3,5.1-5.1,5.1l0,0 C199.2,133.8,196.9,131.5,196.9,128.8L196.9,128.8z M198.2,128.8c0,2.1,1.7,3.8,3.8,3.8l0,0c2.1,0,3.8-1.7,3.8-3.8l0,0 c0-2.1-1.7-3.8-3.8-3.8l0,0C199.9,125,198.2,126.7,198.2,128.8L198.2,128.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_775_",
    className: "st3",
    d: "M222.9,154.1c0,2.4-2,4.4-4.4,4.4s-4.4-2-4.4-4.4s2-4.4,4.4-4.4 C220.9,149.6,222.9,151.6,222.9,154.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_772_",
    d: "M213.4,154.1c0-2.8,2.3-5.1,5-5.1l0,0c2.8,0,5.1,2.3,5.1,5.1l0,0c0,2.8-2.3,5.1-5.1,5.1l0,0 C215.6,159.1,213.4,156.9,213.4,154.1L213.4,154.1z M214.6,154.1c0,2.1,1.7,3.8,3.8,3.8l0,0c2.1,0,3.8-1.7,3.8-3.8l0,0 c0-2.1-1.7-3.8-3.8-3.8l0,0C216.4,150.3,214.7,152,214.6,154.1L214.6,154.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_771_",
    className: "st3",
    d: "M198.2,173.8c0,2.4-2,4.4-4.4,4.4c-2.5,0-4.4-2-4.4-4.4s2-4.4,4.4-4.4 C196.3,169.4,198.2,171.4,198.2,173.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_768_",
    d: "M188.7,173.8c0-2.8,2.3-5.1,5.1-5.1l0,0c2.8,0,5.1,2.3,5.1,5.1l0,0c0,2.8-2.3,5-5.1,5l0,0 C191,178.9,188.7,176.6,188.7,173.8L188.7,173.8z M190,173.8c0,2.1,1.7,3.8,3.8,3.8l0,0c2.1,0,3.8-1.7,3.8-3.8l0,0 c0-2.1-1.7-3.8-3.8-3.8l0,0C191.7,170,190,171.8,190,173.8L190,173.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_767_",
    className: "st3",
    d: "M225.4,199.8c0,2.5-2,4.4-4.4,4.4c-2.5,0-4.4-2-4.4-4.4s2-4.4,4.4-4.4 C223.4,195.3,225.4,197.3,225.4,199.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_764_",
    d: "M215.9,199.8c0-2.8,2.3-5,5.1-5l0,0c2.8,0,5.1,2.3,5.1,5l0,0c0,2.8-2.3,5.1-5.1,5.1l0,0 C218.2,204.8,215.9,202.5,215.9,199.8L215.9,199.8z M217.2,199.8c0,2.1,1.7,3.8,3.8,3.8l0,0c2.1,0,3.8-1.7,3.8-3.8l0,0 c0-2.1-1.7-3.8-3.8-3.8l0,0C218.9,195.9,217.2,197.6,217.2,199.8L217.2,199.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_763_",
    className: "st3",
    d: "M199,242.6c0,2.4-2,4.4-4.4,4.4c-2.5,0-4.4-2-4.4-4.4c0-2.5,2-4.4,4.4-4.4 C197,238.1,199,240.1,199,242.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_760_",
    d: "M189.5,242.6c0-2.8,2.3-5.1,5.1-5.1l0,0c2.8,0,5.1,2.3,5.1,5.1l0,0c0,2.8-2.3,5.1-5.1,5.1l0,0 C191.8,247.6,189.5,245.4,189.5,242.6L189.5,242.6z M190.8,242.6c0,2.1,1.7,3.8,3.8,3.8l0,0c2.1,0,3.8-1.7,3.8-3.8l0,0 c0-2.1-1.7-3.8-3.8-3.8l0,0C192.5,238.8,190.8,240.5,190.8,242.6L190.8,242.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_759_",
    className: "st3",
    d: "M228,234.3c0,2.5-2,4.4-4.4,4.4c-2.5,0-4.4-2-4.4-4.4s2-4.4,4.4-4.4S228,231.9,228,234.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_756_",
    d: "M218.5,234.3c0-2.8,2.3-5.1,5.1-5.1l0,0c2.8,0,5.1,2.3,5.1,5.1l0,0c0,2.8-2.3,5.1-5.1,5.1l0,0 C220.8,239.4,218.5,237.1,218.5,234.3L218.5,234.3z M219.8,234.3c0,2.1,1.7,3.8,3.8,3.8l0,0c2.1,0,3.8-1.7,3.8-3.8l0,0 c0-2.1-1.7-3.8-3.8-3.8l0,0C221.5,230.6,219.8,232.2,219.8,234.3L219.8,234.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_755_",
    className: "st3",
    d: "M224.1,177.2c0,3.1-2.6,5.7-5.7,5.7c-3.2,0-5.7-2.6-5.7-5.7c0-3.2,2.6-5.7,5.7-5.7 C221.6,171.4,224.1,174,224.1,177.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_752_",
    d: "M212.1,177.2c0-3.5,2.9-6.4,6.4-6.4l0,0c3.5,0,6.4,2.9,6.4,6.4l0,0c0,3.5-2.9,6.3-6.4,6.3l0,0 C214.9,183.5,212.1,180.8,212.1,177.2L212.1,177.2z M213.4,177.2c0,2.8,2.3,5.1,5,5.1l0,0c2.8,0,5.1-2.2,5.1-5.1l0,0 c0-2.8-2.3-5.1-5.1-5.1l0,0C215.6,172.1,213.4,174.3,213.4,177.2L213.4,177.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_751_",
    className: "st3",
    d: "M183.4,231.5c0,3.1-2.6,5.7-5.7,5.7c-3.2,0-5.7-2.6-5.7-5.7c0-3.2,2.6-5.7,5.7-5.7 C180.8,225.8,183.4,228.4,183.4,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_748_",
    d: "M171.3,231.5c0-3.5,2.8-6.4,6.4-6.4l0,0c3.5,0,6.3,2.9,6.3,6.4l0,0c0,3.5-2.8,6.3-6.3,6.3l0,0 C174.2,237.9,171.3,235.1,171.3,231.5L171.3,231.5z M172.6,231.5c0,2.8,2.3,5,5.1,5.1l0,0c2.8,0,5.1-2.3,5.1-5.1l0,0 c0-2.8-2.3-5.1-5.1-5.1l0,0C174.8,226.5,172.6,228.8,172.6,231.5L172.6,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_747_",
    className: "st3",
    d: "M203.1,151.2c0,3.8-3,6.8-6.8,6.8c-3.7,0-6.7-3-6.7-6.8c0-3.7,3-6.7,6.7-6.7 C200.1,144.5,203.1,147.5,203.1,151.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_744_",
    d: "M189,151.2c0-4.1,3.3-7.4,7.4-7.4l0,0c4.1,0,7.4,3.3,7.4,7.4l0,0c0,4.1-3.3,7.4-7.4,7.4l0,0 C192.3,158.6,189,155.3,189,151.2L189,151.2z M190.3,151.2c0,3.4,2.7,6.1,6.1,6.1l0,0c3.4,0,6.1-2.7,6.1-6.1l0,0 c0-3.3-2.7-6.1-6.1-6.1l0,0C193,145.2,190.3,147.9,190.3,151.2L190.3,151.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_743_",
    className: "st3",
    d: "M199.8,203.3c0,3.7-3,6.7-6.7,6.7s-6.7-3-6.7-6.7s3-6.8,6.7-6.8 C196.8,196.6,199.8,199.6,199.8,203.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_740_",
    d: "M185.7,203.3c0-4.1,3.3-7.4,7.4-7.4l0,0c4.1,0,7.4,3.3,7.4,7.4l0,0c0,4.1-3.3,7.4-7.4,7.4l0,0 C189,210.8,185.7,207.4,185.7,203.3L185.7,203.3z M186.9,203.3c0,3.3,2.7,6.1,6.1,6.1l0,0c3.4,0,6.1-2.8,6.1-6.1l0,0 c0-3.4-2.7-6.1-6.1-6.1l0,0C189.7,197.2,186.9,199.9,186.9,203.3L186.9,203.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_739_",
    className: "st3",
    d: "M214.7,221c0,3.7-3.1,6.7-6.7,6.7c-3.8,0-6.7-3-6.7-6.7s3-6.7,6.7-6.7 C211.6,214.3,214.7,217.3,214.7,221z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_736_",
    d: "M200.5,221c0-4.1,3.3-7.4,7.4-7.4l0,0c4.1,0,7.4,3.3,7.4,7.4l0,0c0,4.1-3.3,7.3-7.4,7.3l0,0 C203.8,228.4,200.5,225.1,200.5,221L200.5,221z M201.8,221c0,3.4,2.8,6.1,6.1,6.1l0,0c3.4,0,6.1-2.7,6.1-6.1l0,0 c0-3.4-2.7-6.1-6.1-6.1l0,0C204.6,214.9,201.8,217.6,201.8,221L201.8,221z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_735_",
    className: "st2",
    d: "M94.1,110.2c0,0,7.3,7.3,18.2,2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_734_",
    className: "st2",
    d: "M94.1,106.8c0,0,7.3,7.3,18.2,2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_733_",
    d: "M93.4,107.6c5.2,5.1,13.1,5,19.4,2.2c1.1-0.5,0.2-2.1-1-1.7c-5.5,2.4-12.5,2.5-17.1-1.9 C93.8,105.2,92.5,106.7,93.4,107.6L93.4,107.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_732_",
    className: "st3",
    d: "M100.2,226.9l8.2,14.6l0.8,15.7l28.2-2c0,0-5.4-66.7-9-81.1c0,0-0.8-20-1-30.7l-4.4-20 l-8.5-1v14.1l-22.3,0.2l-0.5-13.1l-9.2,1.6l-3.8,32.1L69,188.8L64.9,215l-12.4,45.2l32.3,2.6L100.2,226.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_729_",
    d: "M51.7,260.9l12.5-46.1l4.1-26.3l9.7-31.4l3.9-32.5l10.4-1.8l0.5,13.2l21.1-0.2v-14.1l9.6,1.2l4.5,20.6 c0.2,10.8,1,30.7,1,30.6l0,0c3.6,14.5,9,81.1,9,81.1l0,0v0.7l-29.5,2.1l-0.8-16.2l-7.5-13.4l-15.1,35.1L51.7,260.9L51.7,260.9z  M83.1,125.8l-3.8,31.7l-9.8,31.4L65.4,215l-12.1,44.7l31.1,2.5l15.2-35.5l0.5-1.2l8.9,15.9l0.8,15.1l26.9-2 c-0.6-6.9-5.6-66.9-8.9-80.4l0,0c0,0-0.8-20-1-30.6l0,0l-4.3-19.6l-7.3-0.9v14l-23.6,0.3l-0.5-13L83.1,125.8L83.1,125.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_728_",
    points: "229.6,129.1 230.3,127.3 290.1,152.4 289.4,154.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_727_",
    points: "272.3,146.3 284.9,139.9 285.8,141.6 275.3,147 284.8,158.6 283.3,159.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_726_",
    points: "273.4,149.5 270.1,155.8 268.4,154.9 274.2,143.8 277.6,160.8 275.7,161.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_725_",
    className: "st4",
    d: "M255.9,84.2l-5.1,0.8l7,9.8l-3.4,2.8l-8-10.9l1.6,12.6l-7.4,1l-1.8-9.2l-5.1,0.3l-0.3-8.2 h-3.3c0,0,0.5-9.5-5.9-18.8v5.9l-3.1-3.8l-2.3,3.6l-1.5-2.3l-1.8,4.1l-2.3-2.8l-2,4.1l-3.1-3.3l-1.5,2.3l-3.4-4.3l-4.6,3.6 l-8.7,3.9c0,0-7.2,18.7-7.5,19l-2.8,0.8l-4.1,7.2l-6.9-1.8c0,0,14.6-43.8,37.7-46.9c0,0,20.5-4.9,32.6,8.7 C238.7,62.1,253.1,77.5,255.9,84.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_722_",
    d: "M167.6,100.8l0.2-0.7c0.1,0,14.4-44,38.1-47.3l0,0c0.1,0,3.7-0.9,8.8-0.9l0,0c7.1,0,17.2,1.7,24.4,9.8 l0,0c0,0.1,14.3,15.3,17.3,22.3l0,0l-0.6,0.3l0.6-0.3l0.3,0.8l-4.9,0.7l6.7,9.4l-4.3,3.6l-6.9-9.3l1.3,10.8l-8.7,1.2l-1.8-9.3 l-5.2,0.3l-0.2-8.3h-3.4v-0.7c0,0,0-0.2,0-0.5l0,0c0-1.9-0.3-8.8-4.6-16l0,0v5.6l-3.6-4.6l-2.4,3.7l-0.5-0.8l-0.9-1.3l-1.8,4 l-2.3-2.9l-2.1,4.1L208,71l-1.6,2.4l-3.5-4.6l-4.2,3.3l-8.5,3.7c-0.7,1.9-5.5,14.4-7,17.8l0,0c-0.3,0.6-0.3,0.7-0.5,1.1l0,0 l-0.1,0.1l-0.2,0.1l-2.6,0.7l-4.2,7.3L167.6,100.8L167.6,100.8z M175,101.3l4-7l2.8-0.8c0.1-0.1,0.1-0.3,0.2-0.6l0,0 c0.2-0.5,0.5-1.3,0.9-2.2l0,0c0.7-1.8,1.6-4.2,2.6-6.5l0,0c1.8-4.7,3.6-9.4,3.6-9.4l0,0l0.1-0.3l8.8-3.8l5.1-4l3.2,4.2l1.5-2.2 l3,3.2l2.1-4.2l2.3,2.8l1.8-4.2l0.6,1l1,1.5l2.3-3.5l2.5,3.1v-6.1l1.2,1.7c5.5,8,6,16.1,6,18.5l0,0h3.3l0.2,8.1l5-0.2l1.8,9.2 l6.2-0.9l-1.6-14.4l9,12.2l2.3-2l-7.1-10.1l5.3-0.8c-3.4-6.8-16.7-21.1-16.7-21.1l0,0c-6.8-7.7-16.5-9.4-23.5-9.4l0,0 c-5,0-8.5,0.8-8.5,0.9l0,0c-11.2,1.4-20.6,13-27.1,24.3l0,0c-5.6,9.7-9,19-9.9,21.6l0,0L175,101.3L175,101.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_721_",
    className: "st2",
    d: "M207.7,88.5c-6.9,0-8.7,9.2-0.3,9.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_720_",
    className: "st2",
    d: "M207.7,85.2c-6.9,0-8.7,9.2-0.3,9.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_719_",
    d: "M207.7,84.2c-3.2,0.1-6.6,2.1-6.9,5.6c-0.3,3.8,3.3,5.6,6.6,5.8c1.2,0.1,1.2-1.8,0-1.9 c-2.2-0.1-5.1-1.1-4.7-3.9c0.4-2.4,2.7-3.6,4.9-3.7C208.9,86.1,208.9,84.2,207.7,84.2L207.7,84.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_718_",
    className: "st2",
    d: "M196.4,107.7c0,0,6.9,15.7,20.8-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_717_",
    className: "st2",
    d: "M196.4,104.3c0,0,6.9,15.6,20.8-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_716_",
    d: "M195.5,104.8c1.2,2.6,3.4,5.1,6,6.2c6.6,2.7,12.5-3.4,16.2-8c0.8-1-0.6-2.3-1.4-1.4 c-3.4,4.3-9.1,10.6-15.1,7.1c-1.8-1-3.3-3-4.1-4.9C196.7,102.8,195,103.8,195.5,104.8L195.5,104.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_644_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_682_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_713_",
    className: "st5",
    d: "M299.8,153.9V54.8l30.6-2.2V88h18.4V54.8l30.6-2.2v99.1l-30.6,2.2v-38.4h-18.3v36.2 L299.8,153.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_710_",
    className: "st5",
    d: "M470.1,115.2c0,23.6-17.5,38.7-40.3,38.7c-22.7,0-40.3-15.1-40.3-38.7s17.5-38.7,40.3-38.7 C452.6,76.6,470.1,91.7,470.1,115.2z M419,115.2c0,7.1,4.2,11.7,10.9,11.7c6.7,0,10.9-4.6,10.9-11.7s-4.2-11.7-10.9-11.7 S419,108.2,419,115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_707_",
    className: "st5",
    d: "M488.8,151.8c5.8,2.1,11.7,3.5,18.2,3.5c5.4,0,11.3-1.2,11.3-7.3c0-6.7-7.1-8.2-14.7-8.2 c-4.4,0-8.6,0.5-13,1l2.4-5.1c-11.1-5.5-17.5-14.8-17.5-28.1c0-13.7,10.3-31.1,34-31.1c6.1,0,10.5,0.9,14.4,2.2l22.5-4.5 l-6.6,12.9c5.4,5.2,8.2,12.3,8.2,20.1c0,10.6-4.4,17.8-12.7,23.3c8,4.5,12.4,11.7,12.4,21.1c0,17.9-16.4,27.8-40.9,27.8 c-14.8,0-24.3-3.2-30.4-5.2L488.8,151.8z M512.5,116.8c4.5,0,7.6-3.2,7.6-7.6s-3.1-7.6-7.6-7.6c-4.5,0-7.6,3.3-7.6,7.6 C504.9,113.6,508,116.8,512.5,116.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_704_",
    className: "st5",
    d: "M597.8,153.9v-8.6h-0.3c-4.5,6.3-11.9,8.6-20,8.6c-13.4,0-25-10.2-25-26.1 c0-13.7,11.5-24,26.1-24c7.6,0,12.9,2.7,16.5,5.7v-3.9c0-7.9-5.6-9.6-13.7-9.6c-7.3,0-13.6,1.7-20.1,3.8l5-20.2 c7.9-2.3,17.1-3.1,26-3.1c16.6,0,32.2,7.4,32.2,27.4v47.7L597.8,153.9z M589,121.1c-4,0-7.2,2.7-7.2,6.6c0,3.8,2.7,6.8,7.2,6.8 s7-3.1,7-6.8C596.1,124.5,593.8,121.1,589,121.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_702_",
    className: "st5",
    d: "M636,78.8l25.8-2.2v14h0.3c2.1-9.2,8.6-14,18.9-14c2.1,0,4.3,0.1,6.5,0.4l-6.7,26.8 c-1.1-0.1-2.2-0.1-4.4-0.1c-7,0-12.9,4.5-12.9,14.4v32.5l-27.4,2.2L636,78.8L636,78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_699_",
    className: "st5",
    d: "M586.3,160.4l12.6-1.3v57.5l-11.7,1.3v-6H587c-2.3,4.4-6.9,6-11.8,6 c-11.9,0-21.1-9.7-21.1-21.5c0-12.1,8.8-22.7,21.1-22.7c4,0,8.4,1.4,11.2,4.2L586.3,160.4L586.3,160.4z M576.7,206.6 c5.6,0,10.1-5,10.1-10.9c0-5.8-4.5-10.8-10.1-10.8c-5.7,0-10.1,5-10.1,10.8C566.6,201.6,571.1,206.6,576.7,206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_696_",
    className: "st5",
    d: "M619.2,203.6c1.5,2.1,4.3,3,6.8,3c4.4,0,8.6-2.1,12-4.9l6.6,9.7c-5.5,3.8-11.7,6.5-18.9,6.5 c-13.2,0-22.3-11.5-22.3-21.5c0-12.4,9.8-22.7,21.8-22.7c8.7,0,16.8,5,20.7,12.7L619.2,203.6z M630.8,185.9 c-1.3-1.4-3.4-1.7-5.6-1.7c-5.5,0-9.8,5.2-9.8,10.5v1.4L630.8,185.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_694_",
    className: "st5",
    d: "M664.1,159.1V216l-12.6,1.3v-56.9L664.1,159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_692_",
    className: "st5",
    d: "M380.5,194.9l10.4-2v120h-0.3l-77.2-93.1h-0.3v90.4l-10.5,1.3V192.2h0.3l77.2,92.6h0.3 L380.5,194.9L380.5,194.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_689_",
    className: "st5",
    d: "M428.4,197.3l-7.7,8.7l-7.7-8.7l7.7-8.7L428.4,197.3z M416.6,312.2v-86.4l9.8-2v86.4 L416.6,312.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_686_",
    className: "st5",
    d: "M449.2,311.6v-85.7l9.8-2v13.9h0.3c4.5-7.5,14.1-13.9,24.3-13.9c16.3,0,31.5,6.4,31.5,29.7 v56.7l-9.8,1.3v-60.2c0-12.3-7.9-18.8-21.3-18.8c-9.2,0-25,6.7-25,23v54.6L449.2,311.6z M456.1,213c0.5-7.7,6.4-16.3,14.8-16.3 c4,0,8.1,1.8,12.3,3.7c4.1,2,8.1,3.9,11.6,3.9c5,0,6.7-3.9,7.4-8.3h6.5c-1.5,8.4-4.9,16.3-14.8,16.3c-3.5,0-7.7-1.9-11.9-3.9 c-4.2-1.8-8.3-3.7-11.6-3.7c-4.9,0-7.2,3.9-8.1,8.2h-6.2V213z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_683_",
    className: "st5",
    d: "M614.1,268c0,22.7-18.3,44.2-43.2,44.2s-43.2-21.5-43.2-44.2s18.3-44.2,43.2-44.2 S614.1,245.3,614.1,268z M537.5,268c0,18,14.4,34.4,33.5,34.4c19,0,33.5-16.5,33.5-34.4c0-18-14.5-34.4-33.5-34.4 C551.9,233.6,537.5,250,537.5,268z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHogarDelNino);
export default __webpack_public_path__ + "static/media/hogar-del-nino.df5fedab500a398586246e6f2764fdb5.svg";
export { ForwardRef as ReactComponent };